import * as tslib_1 from "tslib";
import AmCharts from "../AmCharts";
import cx from 'classnames';
import * as React from 'react';
import Styles from "./Charts.css";
import { DEFAULT_SETTINGS } from './constants';
import Utils from './utils/common';

var HeatMapChart =
/** @class */
function (_super) {
  tslib_1.__extends(HeatMapChart, _super);

  function HeatMapChart() {
    var _this = _super !== null && _super.apply(this, arguments) || this;

    _this.getOptions = function () {
      var _a = _this.props,
          title = _a.title,
          data = _a.data,
          timeRange = _a.timeRange,
          disableDownload = _a.disableDownload;

      var options = tslib_1.__assign({}, DEFAULT_SETTINGS, {
        type: 'map',
        path: 'amcharts',
        dataProvider: {
          map: 'usaLow',
          areas: data.data
        },
        colorSteps: 50,
        areasSettings: {
          autoZoom: false,
          alpha: 0.8,
          color: '#67b7dc',
          colorSolid: '#003767',
          unlistedAreasAlpha: 0.4,
          unlistedAreasColor: '#000000',
          outlineColor: '#FFFFFF',
          outlineAlpha: 0.5,
          outlineThickness: 0.5,
          rollOverColor: '#3c5bdc',
          rollOverOutlineColor: '#FFFFFF',
          selectedOutlineColor: '#FFFFFF',
          selectedColor: '#f15135',
          unlistedAreasOutlineColor: '#FFFFFF',
          unlistedAreasOutlineAlpha: 0.5
        },
        imagesSettings: {
          labelColor: '#fff',
          labelPosition: 'middle'
        },
        balloon: {
          adjustBorderColor: true,
          verticalPadding: 25,
          horizontalPadding: 15,
          maxWidth: 200,
          cornerRadius: 0,
          fillColor: '#FFFFFF'
        },
        zoomControl: {
          zoomControlEnabled: true,
          buttonFillColor: '#67b7dc',
          buttonRollOverColor: '#3c5bdc'
        },
        balloonLabelFunction: _this.balloonLabelFunction
      }); // ------------------------------
      // Legend
      // ------------------------------


      var values = data.data.map(function (item) {
        return item.value;
      }).filter(function (v) {
        return v !== undefined;
      });
      options.valueLegend = {
        right: 10,
        minValue: Math.min.apply(Math, tslib_1.__spread(values)),
        maxValue: Math.max.apply(Math, tslib_1.__spread(values))
      }; // ------------------------------
      // Export
      // ------------------------------

      if (!disableDownload) {
        options.export = Utils.getExportOptions(title, timeRange);
      }

      return options;
    };

    _this.balloonLabelFunction = function (item) {
      var _a = _this.props,
          data = _a.data,
          title = _a.title,
          unit = _a.unit;
      var state = item.title;
      var code = item.id.split('-').pop();
      var label = data.meta.y_label || title || '';
      var value = item.value;

      if (label) {
        label += ':';
      }

      if (unit === 'minutes') {
        value = Utils.humanizeSeconds(value);
      }

      return [state + " (" + code + ")", label + " " + value].join('<br />');
    };

    return _this;
  }

  HeatMapChart.prototype.render = function () {
    var _a = this.props,
        height = _a.height,
        className = _a.className;

    var style = tslib_1.__assign({}, height ? {
      height: height
    } : {});

    var options = this.getOptions();
    return React.createElement("div", {
      className: cx(Styles.heatmapChart, className)
    }, React.createElement(AmCharts.React, {
      style: style,
      options: options
    }));
  };

  return HeatMapChart;
}(React.PureComponent);

export default HeatMapChart;